import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getArrowStylesBySize = function getArrowStylesBySize(position) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
  var basePosition = position && position.split('-')[0];
  return _objectSpread({
    borderWidth: size
  }, {
    top: {
      top: '100% !important',
      transform: "rotateZ(".concat(180, "deg)")
    },
    right: {
      right: '100%',
      transform: "rotateZ(".concat(-90, "deg)")
    },
    bottom: {
      bottom: '100%',
      transform: "rotateZ(".concat(0, "deg)")
    },
    left: {
      left: '100%',
      transform: "rotateZ(".concat(90, "deg)")
    }
  }[basePosition]);
};

export default getArrowStylesBySize;
export { getArrowStylesBySize };
//# sourceMappingURL=getArrowStylesBySize.js.map
